import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import {useSearchParams} from "react-router-dom";
import React, {useEffect} from "react";
import {
    fetchInternalOrder,
    resetCreateStatus,
    resetDeleteStatus,
    resetUpdateStatus
} from "../../store/order-internal-slice";
import {useDispatch, useSelector} from "react-redux";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/internalOrderModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {fetchInternalBranchList, fetchInternalEmployeeList, fetchProductList} from "../../store/list-slice";


const ViewInternalOrder = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);
    const {items: employee = []} = list.internalEmployee || {};
    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        deleteStatus,
        pagination,
        error
    } = useSelector((state) => state.internalOrder);

    const {items: internalBranch = []} = list.internalBranch || {};
    const {items: productList} = list.product || {};

    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (deleteStatus === "success") {
            dispatch(resetDeleteStatus());
        }
    }, [dispatch, deleteStatus]);

    useEffect(() => {
        dispatch(fetchInternalEmployeeList({
            ...userRole,
            branchId: userRole.scopeId
        }));
    }, [dispatch, userRole]);

    useEffect(() => {
        dispatch(fetchInternalOrder({...userRole, page: initialPage, limit: initialLimit}));
        dispatch(fetchInternalBranchList(userRole));
        dispatch(fetchProductList({...userRole, allProducts: true}));
    }, [dispatch, initialPage, initialLimit, userRole])

    const tableColumns = getTableColumns({ActionDropdown, userRole});
    const tableData = getTableData({items, internalBranch, productList, employee});
    return (
        <>
            <SubHeader title="All Internal Orders">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    )
}

export default ViewInternalOrder;